import React from 'react';
import PlayListLanding from '../components/PlayListLanding';
function PlayLists() {
  return (
    <div className='playLists'>
      <PlayListLanding />
    </div>
  );
}

export default PlayLists;
